module.exports = __webpack_public_path__ + "static/teacher-hero-55a8f88693df184cfb47cb4063bb1aed.jpg";